import { render, staticRenderFns } from "./NodeTreeItem.vue?vue&type=template&id=665bd603&scoped=true&"
import script from "./NodeTreeItem.vue?vue&type=script&lang=js&"
export * from "./NodeTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./NodeTreeItem.vue?vue&type=style&index=0&id=665bd603&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665bd603",
  null
  
)

export default component.exports